import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Box,Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

const SuccessContainer = styled(Box)(({ theme: { spacing } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  padding: spacing(2, 2)
}))

const PublicRequestForProposalParticipateSuccess: React.FC = () => {
  const { t } = useTranslation()

    return (
        <SuccessContainer>
          <Typography variant="h5" gutterBottom>
            {t('thank-you-for-participating')}
          </Typography>
          <CheckCircleOutlineIcon 
            sx={{ 
              fontSize: 120, 
              color: '#4CAF50', 
              mb: 2 
            }} 
          />
          <Typography variant="body1" color="text.secondary">
            {t('participation-success-info')}
          </Typography>
        </SuccessContainer>
    )
  }

export default PublicRequestForProposalParticipateSuccess